import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {IoniconsOutline, NavigationData} from '@pt/pt-models';
import {WidgetUtils} from '../../documents/widgets/widget.utils';

@Component({
  selector: 'pt-resource-navigation',
  templateUrl: './resource-navigation.component.html',
  styleUrls: ['./resource-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResourceNavigationComponent implements OnInit, AfterViewInit {
  @Input() title = 'Select folder';
  @Input() data: NavigationData[];
  @Input() selectedResourceId: number;
  @Input() enabledSearch = true;

  @Output() clickClose = new EventEmitter();
  @Output() clickItem = new EventEmitter<NavigationData>();

  @ViewChild('navigationList', {static: true}) navigationList: TemplateRef<unknown>;

  resourceNavigationId = WidgetUtils.generateId('rn_');
  path: number[] = [];
  navigationData: NavigationData[];
  IconClose = IoniconsOutline.close;
  IconBack = IoniconsOutline.arrowLeft;
  IconNext = IoniconsOutline.expand;

  currentParentId = null;
  currentList: NavigationData[] = [];
  filterValue: string;

  // IconFilter = IoniconsOutline.filter;

  ngOnInit(): void {
    this.currentParentId = null;
    this.filterValue = null;
    this.navigationData = this.data ? JSON.parse(JSON.stringify(this.data)) : [];

    if (this.selectedResourceId) {

      const currentResource = this.data.find((r) => r.id === this.selectedResourceId);
      if (currentResource) {
        this.currentParentId = currentResource.parentId;
        let pId = this.currentParentId;
        this.path = [];
        while (pId) {
          pId = this.getParentId(pId);
          this.path = [pId].concat(this.path);
        }
      } else {
        this.currentParentId = null;
      }
    } else {
      this.path = [];
      this.currentParentId = null;
    }
    // this.testLog();

    this.changeFilter(this.filterValue);
    this.setFocus();
  }

  getParentId(id: number) {
    if (this.data) {
      const item = this.data.find((d) => d.id == id);
      if (item) {
        return item.parentId;
      }
    }
    return null;
  }

  getTitle() {
    if (this.currentParentId) {
      const parent = this.navigationData.find(d => d.id === this.currentParentId);
      if (parent) {
        return parent.name;
      }
    }
    return this.title;
  }

  goBack() {
    this.currentParentId = this.path.pop();
    this.currentList = this.data.filter(item => item.parentId === this.currentParentId);
    this.filterValue = null;
    this.setFocus();
  }

  expandChildren(data: NavigationData) {
    this.path.push(this.currentParentId);
    this.currentParentId = data.id;
    this.currentList = this.data.filter(item => item.parentId === this.currentParentId);
    this.filterValue = null;
    this.setFocus();
  }

  // childrenOf(parentId: number | null): NavigationData[] {
  //   return this.navigationData?.filter((d) => d.parentId == parentId);
  // }

  changeFilter(value: string) {
    this.filterValue = value;
    this.currentList = this.data.filter(item => item.parentId === this.currentParentId);
    if (this.filterValue) {
      this.currentList = this.currentList.filter(item => item.name.toUpperCase().match(this.filterValue.toUpperCase()));
    }
  }

  selectItem(data: NavigationData) {
    if (data.auth) {
      // this.testLog(data);
      this.clickItem.emit(data);
    }
  }

  haveChildren(data: NavigationData): boolean {
    return !!this.navigationData.find(d => d.parentId === data.id);
  }

  closePanel() {
    this.clickClose.emit();
  }

  ngAfterViewInit(): void {
    this.setFocus();
    document.getElementById('fold_' + this.selectedResourceId)?.scrollIntoView();
  }

  private setFocus() {
    document.getElementById(this.resourceNavigationId)?.focus();
  }

}

